import { clearStore as clearStoreAction } from "../../../../store/actions/index";
import { setCriteria } from "../../../../store/actions/production/productionActions";
import { persistor } from "../../../../store";
import {
  setAgencySessionVariables,
  getAgencyInfoForBDSAdminAccount,
} from "../../../../services/GraphQl/BDSWebService";
import history from "../../../../utils/history";

const ClearStoreData = (props) => {
  const { inputId, dispatch, value } = props;
  const reOpen = () => {
    history.push("/main");
  };
  const clearStore = async () => {
    dispatch(clearStoreAction());
    dispatch(
      setCriteria({
        selectedCarrier: "",
        selectedAgency: "",
        selectedLevel: "",
        selectedPlanYear: "",
        selectedProducts: "",
        displayCounty: false,
        displayEffectiveData: false,
        displayState: false,
        displayWritingNumber: false,
      })
    );
    persistor.purge();    

    await getAgencyInfoForBDSAdminAccount(inputId.toString()).then(async (res) => {
      if (res) {
        setAgencySessionVariables(res[0]);
      }
    });
  };
  clearStore().then(() => {
    sessionStorage.setItem("parentAgency", value);
    reOpen();
  });
};

export default ClearStoreData;
